var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRss = function SvgRss(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.5 3.75a.75.75 0 0 0 0 1.5c7.318 0 13.25 5.932 13.25 13.25a.75.75 0 0 0 1.5 0c0-8.146-6.604-14.75-14.75-14.75Zm0 4.666a.75.75 0 1 0 0 1.5 8.583 8.583 0 0 1 8.583 8.583.75.75 0 1 0 1.5 0c0-5.568-4.514-10.083-10.083-10.083Zm-.75 5.418a.75.75 0 0 1 .75-.75 5.417 5.417 0 0 1 5.417 5.417.75.75 0 0 1-1.5 0A3.917 3.917 0 0 0 5.5 14.584a.75.75 0 0 1-.75-.75ZM5.5 19.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    clipRule: "evenodd"
  })));
};
export default SvgRss;